export enum RegisterRoutePathsEnum {
  REGISTER = '/register',
}
